var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"btn",attrs:{"id":"RECORD","name":"RECORD","data-vcode":"RECORD"}},[_c('img',{staticClass:"soft-img",attrs:{"src":"/images/icn-record.svg","alt":"","role":"img","aria-hidden":"true"}}),_c('label',[_vm._v(" "+_vm._s(_vm.$t('recordButton')))])])
}
var staticRenderFns = []

export { render, staticRenderFns }